<template>
    <v-container
        :id="
            content.columnId && content.columnId[$i18n.locale]
                ? content.columnId[$i18n.locale].current
                : content._key
        "
        :fluid="content.fullWidth"
        class="htmlcontent pb-0"
    >
        <!-- <v-row>
            <pre>{{ content }}</pre>
        </v-row> -->
        <v-row column justify-center align-center>
            <v-col v-if="content.heading" cols="12">
                <h3>{{ content.heading[$i18n.locale] }}</h3>
            </v-col>
            <v-col
                v-if="content.blurbage && content.blurbage[$i18n.locale]"
                cols="12"
            >
                <!-- TODO: Configure auto-insertion of thumbnail images to certain content types -->
                <!-- <EmbedCloudinary
                    v-if="thumbnail && context !== 'column'"
                    :image-id="img.id"
                    :image-dir="img.dir"
                    :image-align="img.align"
                    classes="mt-0"
                    :mobile-width="img.mobile"
                    :tablet-width="img.tablet"
                    :desktop-width="img.desktop"
                    :alt="img.alt"
                /> -->
                <!-- <pre>{{ content2.blurbage }}</pre> -->
                <BlockContent
                    :blocks="content2.blurbage[$i18n.locale]"
                    :serializers="serializers"
                />
            </v-col>
            <v-col v-if="content && content.ctaLinks" cols="12">
                <CtaLinks :links="content.ctaLinks" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import CtaLinks from '~/components/CtaLinks.vue'
import serializers from '~/util/sanity/serializers'
import setCloudinaryData from '~/util/setCloudinaryData'
export default {
    name: 'HtmlContent',
    components: {
        CtaLinks,
        // EmbedCloudinary
    },
    props: {
        content: {
            type: Object,
            default: null,
        },
        context: {
            type: String,
            default: '',
        },
        thumbnail: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            serializers,
        }
    },
    computed: {
        img() {
            return this.thumbnail
                ? setCloudinaryData(this.thumbnail, 'thumbnail')
                : {}
        },
        content2() {
            var temp = this.content
            temp.blurbage.en.map((x) => {
                if (x._type === 'cloudinary') {
                }
                // x.height = '500'
                x.width = '800'
            })
            temp.blurbage.es.map((x) => {
                if (x._type === 'cloudinary') {
                }
                // x.height = '500'
                x.width = '800'
            })
            return temp
        },
    },
}
</script>
